import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { CompanyApi } from '../../../../api/companies.api';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return CompanyLegacyComponent; }),
    multi: true
};
var CompanyLegacyComponent = /** @class */ (function () {
    function CompanyLegacyComponent(fuseTranslationLoaderService, companiesApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.companiesApi = companiesApi;
        this.required = false;
        this.floatLabel = true;
        this.disabled = false;
        this.appearance = 'outline';
        this.companies = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
    }
    CompanyLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges
            .pipe(debounceTime(500))
            .subscribe(function (value) {
            _this.companies = [];
            if (value) {
                _this.searchCompanies({ name_contains: value, archived: false });
            }
        });
    };
    CompanyLegacyComponent.prototype.searchCompanies = function (query) {
        var _this = this;
        this.loading = true;
        this.companiesApi.search(query).subscribe(function (result) {
            _this.loading = false;
            _this.companies = result.items;
        });
    };
    CompanyLegacyComponent.prototype.writeValue = function (companyId) {
        var _this = this;
        if (companyId) {
            this.companiesApi.searchOne(companyId).then(function (company) {
                _this.selectedCompany = company;
                _this.hasSelectedCompany = true;
                _this.inputValue.setErrors(null);
                _this.inputValue.setValue(companyId);
            });
        }
        else {
            this.deselectCompany();
        }
    };
    CompanyLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    CompanyLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    CompanyLegacyComponent.prototype.setSelectedCompany = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedCompany = _.find(this.companies, function (company) { return company.id === _this.inputValue.value; });
            this.hasSelectedCompany = true;
            this.inputValue.setErrors(null);
        }
    };
    CompanyLegacyComponent.prototype.deselectCompany = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedCompany = null;
        this.hasSelectedCompany = false;
        this.inputValue.setErrors(null);
    };
    return CompanyLegacyComponent;
}());
export { CompanyLegacyComponent };
